
import BreadcrumbView from "../common/breadcrumb/breadcrumb.html";
import RgpdListView from "./rgpd-list.html";

angular.module("rgpd", [])

    .config(['$stateProvider', function ($stateProvider) {
        $stateProvider
            .state('rgpd', {
                url: "/rgpd",
                abstract: true,
                controller: "BreadcrumbCtrl",
                template: BreadcrumbView,
            })
            .state('rgpd.list', {
                url: "/list",
                controller: "RgpdListCtrl",
                template: RgpdListView,
                cache: false,
                data: { pageTitle: 'RGPD' },
                requiredPermission: ["RGPD"]
            })
        ;
    }])
;